"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MobileContainer = void 0;
var react_1 = __importStar(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var QwilrLogoLettering_svg_1 = __importDefault(require("@ClientAssets/icons/QwilrLogoLettering.svg"));
var react_dom_1 = require("react-dom");
var react_transition_group_1 = require("react-transition-group");
var kaleidoscope_2 = require("@qwilr/kaleidoscope");
var utils_1 = require("@qwilr/kaleidoscope/utils");
var icons_1 = require("@qwilr/kaleidoscope/icons");
var Navigation_1 = require("Common/Navigation/Navigation");
var Sidebar_1 = require("./Sidebar");
function MobileContainer(_a) {
    var isMobileSidebarOpen = _a.isMobileSidebarOpen, setIsMobileSidebarOpen = _a.setIsMobileSidebarOpen, menuComponents = _a.menuComponents, children = _a.children;
    var mobileSidebarCloseButton = (0, react_1.useRef)();
    var localStates = (0, react_1.useRef)({
        prevFocusElement: undefined,
        timeoutIdOnBlur: undefined,
    });
    var mobileSidebarRoot = (0, utils_1.getPortalRoot)("mobile-sidebar-root");
    var handleSidebarInteraction = (0, react_1.useCallback)(function (event) {
        event.nativeEvent.stopPropagation();
        event.stopPropagation();
    }, []);
    var handleSidebarKeydown = (0, react_1.useCallback)(function (event) {
        if (event.key === "Escape") {
            setIsMobileSidebarOpen(false);
        }
    }, [setIsMobileSidebarOpen]);
    var handleSidebarEnter = function (node) {
        var _a;
        localStates.current.prevFocusElement = document.activeElement;
        (_a = mobileSidebarCloseButton.current) === null || _a === void 0 ? void 0 : _a.focus();
        (0, utils_1.forceReflow)(node);
    };
    var handleSidebarExit = function () {
        var prevFocusElement = localStates.current.prevFocusElement;
        prevFocusElement === null || prevFocusElement === void 0 ? void 0 : prevFocusElement.focus();
    };
    var handleBlur = function () {
        localStates.current.timeoutIdOnBlur = window.setTimeout(function () {
            setIsMobileSidebarOpen(false);
        });
    };
    var handleFocus = function () {
        clearTimeout(localStates.current.timeoutIdOnBlur);
    };
    return (react_1.default.createElement(react_transition_group_1.Transition, { mountOnEnter: true, unmountOnExit: true, in: isMobileSidebarOpen, timeout: kaleidoscope_2.AnimationDuration.Long, onEnter: handleSidebarEnter, onExit: handleSidebarExit }, function (status) {
        return (0, react_dom_1.createPortal)(react_1.default.createElement("div", { className: (0, classnames_1.default)("".concat(Sidebar_1.className), "".concat(Sidebar_1.className, "--mobile"), "".concat(Sidebar_1.className, "--").concat(status)), onMouseDown: handleSidebarInteraction, onTouchStart: handleSidebarInteraction, onKeyDown: handleSidebarKeydown, onBlur: handleBlur, onFocus: handleFocus, tabIndex: -1 },
            react_1.default.createElement("div", { className: "".concat(Sidebar_1.className, "__header") },
                react_1.default.createElement(kaleidoscope_1.SVG, { src: QwilrLogoLettering_svg_1.default, className: "".concat(Navigation_1.BASE_CLASS_NAME, "__logo") }),
                react_1.default.createElement(kaleidoscope_2.IconButton, { icon: react_1.default.createElement(icons_1.Close, null), "aria-label": "Close menu", onClick: function () { return setIsMobileSidebarOpen(false); }, ref: mobileSidebarCloseButton })),
            menuComponents,
            children), mobileSidebarRoot);
    }));
}
exports.MobileContainer = MobileContainer;
